import FGTSPage from 'screens/FGTS/FGTS';

export default FGTSPage;
